export const SUBSCRIPTION_REQUEST_API_ROUTES = {
    GET_INSTITUTE_TYPE: 'institute/instituteCategoryList',
    SEND_SUBSCRIPTION_REQUEST:'institute/instituteSubscriptionContact'
    // SUBSCRIBE_STUDENT_PLAN: 'subscription/subscribeStudentPlan'
}

export const RECAPTCHA_SITE_KEY="6LcKjjMsAAAAADyiChhNkliGAOENXZKXAdQe_NU2"
